export default "__VITE_ASSET__68794912__"